import { render, staticRenderFns } from "./finImprint.vue?vue&type=template&id=6c603a86&scoped=true&"
import script from "./finImprint.vue?vue&type=script&lang=js&"
export * from "./finImprint.vue?vue&type=script&lang=js&"
import style0 from "./finImprint.vue?vue&type=style&index=0&id=6c603a86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c603a86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VImg,VRow})
